var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 56,
    viewBox: "0 0 136 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4103 12.0795L19.8863 12.002C19.4824 12.002 19.2807 12.4867 19.5637 12.7741L26.1651 19.4172C26.5907 19.8466 27.1703 20.0879 27.7754 20.0879H51.6743C52.0782 20.0879 52.2799 19.601 51.9947 19.3158L45.0095 12.3284C44.8511 12.17 44.6353 12.0789 44.4119 12.0789H44.4098L44.4103 12.0795Z",
    fill: "#039EF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.397 28.6246H52.8235V43.1493C52.8235 43.6183 52.4434 44 51.9728 44H36.2152C35.873 44 35.699 43.5863 35.9403 43.3434L43.1473 36.0475H44.7598V28.6208H43.1847L44.7598 27.0452L47.6986 24.1048L48.7868 23.0166L54.397 28.6263V28.6241V28.6246Z",
    fill: "#039EF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06413 31.0445V19.9531H12.6512L28.6105 35.9124H0.805611C0.530712 35.9124 0.391907 36.2448 0.586017 36.4405L7.37553 43.23C7.81472 43.6692 8.41277 43.9186 9.03414 43.9208L31.3557 43.9961C31.8545 43.9961 32.3355 43.8004 32.6895 43.448L39.5425 36.6173C39.8748 36.2849 39.8748 35.7465 39.5425 35.4141L16.9536 12.8214C16.4277 12.295 15.7147 12 14.9708 12H0.851699C0.380521 12 0.000976562 12.3801 0.000976562 12.8507V31.0461C0.000976562 31.5151 0.380521 31.8968 0.851699 31.8968H7.21558C7.68459 31.8968 8.0663 31.5167 8.0663 31.0461L8.06413 31.0439V31.0445Z",
    fill: "#039EF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1445 38.4276C60.6068 38.4276 59.6113 37.6083 59.6113 35.8727V35.7697C59.6113 34.0341 60.6741 33.2148 62.3066 33.2148C62.8331 33.2148 63.3612 33.2739 63.7711 33.397V34.129C63.3238 33.9902 62.8846 33.9311 62.3283 33.9311C61.0975 33.9311 60.5195 34.5308 60.5195 35.7833V35.8483C60.5195 37.1068 61.046 37.7087 62.1521 37.7087C62.5262 37.7087 62.8331 37.687 63.1118 37.6273V36.1634H61.8593L62.0415 35.4449H64.0184V38.1538C63.3081 38.3436 62.8331 38.4249 62.1445 38.4249V38.4271V38.4276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3292 33.251H71.2298L73.3396 38.384H72.3441L71.964 37.3886H69.5994L69.2117 38.384H68.2168L70.3325 33.251H70.3303H70.3292ZM71.6988 36.6783L70.7847 34.2974L69.8548 36.6783H71.6994H71.6988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6285 33.2588L80.4232 37.2641L82.2098 33.2588H83.2725V38.3843H82.3724V34.7808L80.7691 38.3843H80.0805L78.4778 34.7808V38.3843H77.5771V33.2588H78.6323H78.6285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7861 33.2588V38.3843H87.8779V33.4865L88.7861 33.2588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1525 33.2588L96.8023 36.8764V33.2588H97.7105V38.3843H96.927L94.2832 34.7585V38.3843H93.375V33.2588H94.1509H94.1525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.68 38.4276C103.143 38.4276 102.146 37.6083 102.146 35.8727V35.7697C102.146 34.0341 103.209 33.2148 104.842 33.2148C105.368 33.2148 105.896 33.2739 106.306 33.397V34.129C105.859 33.9902 105.42 33.9311 104.863 33.9311C103.633 33.9311 103.055 34.5308 103.055 35.7833V35.8483C103.055 37.1068 103.583 37.7087 104.687 37.7087C105.061 37.7087 105.368 37.687 105.647 37.6273V36.1634H104.394L104.579 35.4449H106.556V38.1538C105.845 38.3436 105.37 38.4249 104.682 38.4249L104.68 38.4271V38.4276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.006 17.5744H59.6123V28.0011H69.006C70.9233 28.0011 72.493 26.4379 72.493 24.5141V21.0592C72.493 19.1317 70.9179 17.5723 69.006 17.5723V17.5744ZM62.6796 20.6417H68.7864C69.1389 20.6417 69.4235 20.9264 69.4235 21.2788V24.2967C69.4235 24.647 69.1383 24.9338 68.7864 24.9338H62.6796V20.6395V20.6417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3459 17.5742H76.8179L72.4922 28.0008H75.8105L78.8642 20.6415V19.8759H79.2974V20.6415L82.3528 28.0008H85.6732L81.3459 17.5742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0195 17.5742V20.6415H88.9254V28.0008H91.9927V20.6415H96.8996V17.5742H84.0195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.461 20.2652C135.31 19.6341 134.992 19.0582 134.531 18.5974C134.068 18.1343 133.492 17.8139 132.861 17.6675C132.604 17.6062 132.335 17.5742 132.068 17.5742H122.674V28.0008H125.741V25.5468H132.068C132.186 25.5468 132.311 25.5387 132.43 25.5289C132.576 25.5148 132.723 25.4893 132.861 25.4557C133.492 25.3093 134.068 24.9867 134.531 24.5258C134.992 24.065 135.311 23.4886 135.459 22.8575V22.8493L135.463 22.8396C135.52 22.5842 135.552 22.3229 135.552 22.0599V21.0584C135.552 20.7895 135.518 20.5244 135.461 20.2652H135.461ZM125.737 20.6415H131.846C132.198 20.6415 132.483 20.9261 132.483 21.2786V21.8446C132.483 22.1949 132.198 22.4801 131.846 22.4801H125.739V20.6415H125.737H125.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.449 17.5742V17.8827L118.446 24.9336H112.341C111.991 24.9336 111.704 24.6484 111.704 24.2987V17.5742H108.639V25.0404C108.753 25.8 109.12 26.5125 109.675 27.0449C110.232 27.5834 110.96 27.9195 111.728 27.9987H111.743L117.638 28.0008L118.517 27.0292V28.0008H121.517V17.5742H118.452H118.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.019 17.5742H99.492L95.1641 28.0008H98.4845L101.538 20.6415V19.8759H101.969V20.6415L105.027 28.0008H108.345L104.019 17.5742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.552,
    height: 32,
    fill: "white",
    transform: "translate(0 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/Page.b8da916fc2d68d97a1944b8495c4e29c.svg";
export { ForwardRef as ReactComponent };